












































































































































































import axios from 'axios';
import { get, cloneDeep, filter } from 'lodash';
import EventBus from '../../../../../eventBus';

import { Page } from '../../../../Molecules/co-card-page/models.ts';
import CoCardPage from '../../../../Molecules/co-card-page/CoCardPage.vue';
import CoRoundButton from '../../../../Atoms/co-round-button/CoRoundButton.vue';
import CoButton from '../../../../Atoms/co-button/CoButton.vue';
import CoConfirmation from '../../../../Molecules/co-confirmation/CoConfirmation.vue';
import CoAlert from '../../../../Molecules/co-alert/CoAlert.vue';
import CoText from '../../../../Atoms/co-text/CoText.vue';
import CoContentSection from '../../../../Organisms/сo-content-section/CoContentSection.vue';
import { createAudioSection, getSectionKey } from '../../../../Organisms/сo-content-section/models.ts';

export default {
    name: 'PagesForChannel',
    components: {
        CoCardPage,
        CoRoundButton,
        CoButton,
        CoConfirmation,
        CoAlert,
        CoText,
        CoContentSection,
    },
    i18n: {
        messages: {
            en: {
                ctaheader: 'Start to share what you know.',
                ctasubline: 'Create a page on your community platform.',
                createpagepermissiontitle: 'Who can add pages to this channel',
                everyone: 'Everyone',
                adminsonly: 'Admins only',
                channelDeleteFailed: 'Failed to delete channel',
                channelDeleted: 'Channel deleted',
                deleteChannel: 'Delete Channel',
            },
            de: {
                ctaheader: 'Fang an, dein Wissen weiterzugeben.',
                ctasubline: 'Erstelle eine Seite auf deiner Community-Plattform.',
                createpagepermissiontitle: 'Wer darf Seiten zu diesem Kanal hinzufügen',
                everyone: 'Jeder',
                adminsonly: 'Nur Admins',
                channelDeleteFailed: 'Kanal konnte nicht gelöscht werden',
                channelDeleted: 'Kanal gelöscht',
                deleteChannel: 'Kanal löschen',
            },
        },
    },
    data() {
        return {
            isAdmin: this.$store.state.me.Permissions && this.$store.state.me.Permissions.includes('space_admin'),
            feed: [],
            feedNextPage: null,
            loading: true,
            expand: false,
            windowWidth: window.innerWidth,
            channelSlug: this.$route.params.slug,
            channelID: this.$route.query.id,
            lastEvaluatedKey: null, // used for pagination
            channelList: null,
            userProfiles: {},
            pages: Array<Page>(),
            listRerenderKey: 0,

            currentChannel: null,

            showChannelSetting: false,
            addPagesPermission: 0,
            addPagesPermissionEveryone: true,
            addPagesPermissionAdmins: false,
            channelSettingsLoading: false,
            sectionsRerenderKey: 0,
        };
    },
    watch: {
        $route(to) {
            this.channelSlug = to.params.slug;
            this.channelID = to.query.id;
            this.reset();
            this.getChannelList();
        },
        addPagesPermissionEveryone(val) {
            this.addPagesPermission = val ? 0 : 1;
            this.addPagesPermissionAdmins = !val;
        },
        addPagesPermissionAdmins(val) {
            this.addPagesPermission = val ? 1 : 0;
            this.addPagesPermissionEveryone = !val;
        },
    },
    computed: {
        canCreatePages() {
            return this.$store.state.permissions && this.$store.state.permissions['pages.create'] === true;
        },
        canIEditChannel() {
            return this.currentChannel && this.currentChannel.SpaceID === this.$store.state.space.ID && this.isAdmin;
        },
        me() {
            return this.$store.state.me;
        },
        isDesktop() {
            return this.windowWidth >= 768;
        },
    },
    created() {
        window.addEventListener('scroll', this.scroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.scroll);
    },
    mounted() {
        this.scroll();

        this.getChannelList();
    },
    methods: {
        getSectionKey,
        get,
        discard() {
            this.currentChannel = cloneDeep(this.getCurrentChannel());
            this.addPagesPermissionAdmins = this.currentChannel && this.currentChannel.AddPagesPermission === 1;
            this.showChannelSetting = false;
        },
        deleteChannel() {
            this.channelSettingsLoading = true;
            axios({
                method: 'DELETE',
                url: '/admin/community/project-type',
                data: JSON.stringify({ ID: this.currentChannel.ID }),
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(() => {
                    this.showChannelSetting = false;
                    EventBus.$emit('INFO', {
                        Message: this.$t('channelDeleted'),
                        Details: null,
                    });
                    this.$router.push('/');
                    this.$router.go();
                })
                .catch((error) => {
                    console.log(error);
                    EventBus.$emit('ERROR', {
                        Message: this.$t('channelDeleteFailed'),
                        Details: null,
                    });
                })
                .finally(() => {
                    this.channelSettingsLoading = false;
                });
        },

        saveChannelSettings() {
            this.channelSettingsLoading = true;
            let data = this.currentChannel;
            data.AddPagesPermission = this.addPagesPermission ?? 0;

            data = JSON.stringify(data);

            axios({
                method: 'PUT',
                url: '/admin/community/project-type',
                data,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.showChannelSetting = false;
                    // update channel slug for page creation
                    if (response?.data?.Slug) {
                        this.channelSlug = response.data.Slug;
                    }
                    // give user feedback
                    EventBus.$emit('INFO', {
                        Message: this.$t('labels.changessaved'),
                        Details: null,
                    });
                })
                .catch((error) => {
                    console.log(error);
                    EventBus.$emit('ERROR', {
                        Message: this.$t('labels.failedToSaveChanges'),
                        Details: null,
                    });
                })
                .finally(() => {
                    this.channelSettingsLoading = false;
                });
        },
        create() {
            this.$router.push(`/create/page?channel=${this.channelSlug}`);
        },
        mapSpaceObject(spaceItme) {
            if (!spaceItme) {
                return null;
            }

            if (!spaceItme.ID) {
                return null;
            }

            if (spaceItme.ID === this.$store.state.space.ID) {
                return null;
            }
            const obj = {
                id: spaceItme.ID,
                name: spaceItme.Name,
                favicon: spaceItme.FaviconURL,
                primaryColor: spaceItme.PrimaryColor,
            };
            return obj;
        },

        mapFeedEntriesToPages(feedEntries, startIndex = 0) {
            // Build rendered page objects only after contributor profiles have been fetched.
            return (feedEntries || []).map((feedpost, index) => {
                const page = feedpost.object || {};
                const contributors = (page.Contributor || page.Owner || [])
                    .map((id) => this.userProfiles[id])
                    .filter(Boolean);
                const tmpImages = page.Images || page.ImageURL || page.ImageURLs || [];

                page.Contributors = contributors;
                page.Images = tmpImages.map((image) => {
                    if (image && typeof image === 'object' && 'ImageURL' in image) {
                        return image;
                    }
                    return {
                        ImageURL: image || null,
                    };
                });

                if (page.Images.length === 0) {
                    page.Images = [{ ImageURL: null }];
                }

                if (feedpost.space) {
                    // Preserve the original space shape so CoCardPage can show cross-space metadata.
                    page.Space = feedpost.space;
                }

                // Use a dedicated render key so Vue never depends on partial page data for list identity.
                page.renderKey = `${page.ID || page.Slug || 'page'}-${startIndex + index}`;

                return page;
            });
        },
        reset() {
            this.feedNextPage = null;
            this.lastEvaluatedKey = null;
            this.feed = [];
            this.pages = [];
            this.userProfiles = {};
        },
        getContributorProfiles(pageList) {
            const userIDs: string[] = (pageList || []).reduce((acc, page) => {
                const contributorIDs: string[] = (page && (page.Contributor || page.Owner || [])) || [];
                return acc.concat(contributorIDs);
            }, [] as string[]);
            const uniqueUserIDs = Array.from(new Set(userIDs));
            const idsToFetch = uniqueUserIDs.filter((id) => !this.userProfiles[id]);

            if (idsToFetch.length === 0) {
                return Promise.resolve();
            }

            const data = JSON.stringify({ IDS: idsToFetch.map((id) => ({ ID: id })) });
            return this.$store.dispatch('listUsersByIDs', { ids: data }).then((response) => {
                if (response.Users) {
                    response.Users.forEach((user) => {
                        this.$set(this.userProfiles, user.ID, {
                            ...user,
                            ...user.Profile,
                        });
                    });
                }
            });
        },
        getProjectsByNewest() {
            // this.feedNextPage = null;
            let url = `/project/list/${this.channelSlug}`;
            if (this.feedNextPage) {
                url = this.feedNextPage;
            }

            this.selected = 'Newest';
            this.loading = true;
            // get projects for channel
            axios
                .get(url, {})
                .then(async (response) => {
                    if (response.data.objects) {
                        const entries = response.data.objects;

                        this.feed.push(...entries);

                        const startIndex = this.pages.length;
                        await this.getContributorProfiles(entries.map((entry) => entry.object));
                        this.pages.push(...this.mapFeedEntriesToPages(entries, startIndex));

                        if (response.data.next !== '' && response.data.next !== null) {
                            this.feedNextPage = response.data.next;
                        } else {
                            this.feedNextPage = null;
                        }

                        if (this.feed.length < 10 && this.feedNextPage !== null) {
                            this.getProjectsByNewest();
                        } else {
                            this.loading = false;
                        }
                    }
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                    console.log(error);

                    // todo show error
                });
        },

        listPages() {
            this.loading = true;
            // get projects for channel
            const data = {
                ChannelID: this.channelID,
                LastEvaluatedKey: this.lastEvaluatedKey,
            };
            axios({
                method: 'POST',
                url: '/page/list',
                data,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(async (response) => {
                    if (response.data.Objects) {
                        const entries = response.data.Objects;

                        this.feed.push(...entries);

                        const startIndex = this.pages.length;
                        await this.getContributorProfiles(entries.map((entry) => entry.object));
                        this.pages.push(...this.mapFeedEntriesToPages(entries, startIndex));

                        if (
                            response.data.LastEvaluatedKey &&
                            response.data.LastEvaluatedKey !== '' &&
                            response.data.LastEvaluatedKey !== null
                        ) {
                            this.lastEvaluatedKey = response.data.LastEvaluatedKey;
                        } else {
                            this.lastEvaluatedKey = null;
                        }

                        if (this.feed.length < 10 && this.lastEvaluatedKey !== null) {
                            this.listPages();
                        } else {
                            this.loading = false;
                        }
                    }
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                    console.log(error);
                    // todo show error
                });
        },

        scroll() {
            window.onscroll = () => {
                const distanceFromBottom = document.body.scrollHeight - window.innerHeight - window.scrollY;

                const percentage = (distanceFromBottom * 100) / (document.body.scrollHeight - window.innerHeight);

                if (percentage < 1) {
                    if (this.channelID && this.lastEvaluatedKey && !this.loading) {
                        this.listPages();
                    }
                }
            };
        },
        getChannelList() {
            /* get the list of channels and save them in the channelList map with slug as keys */
            axios
                .post('/channel/list/circles')
                .then((response) => {
                    if (response.data && response.data.Objects) {
                        // find channel title by slug
                        this.channelList = response.data.Objects;
                        this.currentChannel = cloneDeep(this.getCurrentChannel());

                        if (!this.currentChannel) {
                            this.$router.push('/not-found/page').catch((error) => error); // redirect to not found page
                            return;
                        }

                        this.channelID = this.currentChannel.ID;
                        this.addPagesPermissionAdmins =
                            this.currentChannel && this.currentChannel.AddPagesPermission === 1;
                        this.listPages();
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getCurrentChannel() {
            if (!this.channelList) {
                return null;
            }

            if (this.channelID) {
                const currentChannelEntry = this.channelList.filter((entry) => entry.object.ID === this.channelID)[0];
                if (currentChannelEntry) {
                    return currentChannelEntry.object;
                }
            }
            const channle = this.channelList.filter((channel) => channel.object.Slug === this.channelSlug)[0];
            if (!channle) {
                return null;
            }

            if (channle.object.SpaceID !== this.$store.state.space.ID) {
                return null;
            }

            return channle.object;
        },

        saveSection(section, index) {
            this.currentChannel.Sections[index] = section;
            this.sectionsRerenderKey += 1;
            this.saveChannelSettings();
        },
        deleteSection(index) {
            if (!this.currentChannel.Sections) {
                this.sectionsRerenderKey += 1;
                return;
            }
            this.currentChannel.Sections.splice(index, 1);
            this.sectionsRerenderKey += 1;
            this.saveChannelSettings();
        },
        moveSectionDown(index) {
            if (!this.currentChannel.Sections) {
                this.sectionsRerenderKey += 1;
                return;
            }
            const temp = this.currentChannel.Sections[index];
            this.currentChannel.Sections[index] = this.currentChannel.Sections[index + 1];
            this.currentChannel.Sections[index + 1] = temp;
            this.sectionsRerenderKey += 1;
            this.saveChannelSettings();
        },
        moveSectionUp(index) {
            if (!this.currentChannel.Sections) {
                this.sectionsRerenderKey += 1;
                return;
            }
            const temp = this.currentChannel.Sections[index];
            this.currentChannel.Sections[index] = this.currentChannel.Sections[index - 1];
            this.currentChannel.Sections[index - 1] = temp;
            this.sectionsRerenderKey += 1;
            this.saveChannelSettings();
        },
        addSection($event, index) {
            if (!Array.isArray(this.currentChannel.Sections)) {
                this.$set(this.currentChannel, 'Sections', []);
            }
            const insertIndex = typeof index === 'number' ? index + 1 : this.currentChannel.Sections.length;
            if ($event === 'text') {
                this.currentChannel.Sections.splice(insertIndex, 0, {
                    Type: 0,
                    Content: '',
                    StartEditMode: true,
                });
            } else if ($event === 'image') {
                this.currentChannel.Sections.splice(insertIndex, 0, {
                    Type: 1,
                    Images: [],
                    StartEditMode: true,
                });
            } else if ($event === 'video') {
                this.currentChannel.Sections.splice(insertIndex, 0, {
                    Type: 3,
                    Content: '',
                    StartEditMode: true,
                });
            } else if ($event === 'audio') {
                this.currentChannel.Sections.splice(insertIndex, 0, createAudioSection());
            } else if ($event === 'code') {
                this.currentChannel.Sections.splice(insertIndex, 0, {
                    Type: 2,
                    Content: '',
                    StartEditMode: true,
                });
            }
        },
    },
};
